import { render, staticRenderFns } from "./PoiUser.vue?vue&type=template&id=56933cae"
import script from "./PoiUser.vue?vue&type=script&lang=js"
export * from "./PoiUser.vue?vue&type=script&lang=js"
import style0 from "./PoiUser.vue?vue&type=style&index=0&id=56933cae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports